import React from 'react';
import './heading.scss';

const Heading = (props) => {
  const planName = props.planName;
  return <h1 className="mdn-Heading mdn-Heading--md nome-plano">{planName}</h1>;
};

export default Heading;
